require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-the-city-of-salisbury.json") })
        }
      }, "path---authors-the-city-of-salisbury");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-the-city-of-salisbury!./.cache/json/authors-the-city-of-salisbury.json
// module id = 1346
// module chunks = 231608221292675